import lodash, { orderBy } from 'lodash-es'
import axios from 'axios'
import {
  SET_TRAINEES,
  SET_FILTRED_LIST,
  SET_COMPLIANCE_LIST,
} from '../mutation-types'

const trainees = {
  namespaced: true,
  state: {
    filtredTrainee: '',
    selectedTrainees: [],
    compliancesList: [],
    isFiltrSelected: false,
    isAllTrainnesSelected: false,
    trainees: [],
    pagination: {},
    limit: 15,
    services: [],
    functions: [],
    orderDirection: 'firstname',
    orderBy: 'firstname',
  },
  mutations: {
    [SET_TRAINEES](state, data) {
      state.trainees = data.data
      state.pagination = data.meta.pagination
    },
    [SET_FILTRED_LIST](state, data) {
      state.filtredTrainee = data.data
    },
    [SET_COMPLIANCE_LIST](state, data) {
      state.compliancesList = data
    },
  },
  actions: {
    getEstablishments({ commit, state, rootState }, params = {}) {
      let data = {
        companyId: lodash.get(rootState, 'company.id', null),
        establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return axios
        .post(
          rootState.apiBaseURL + '/establishments/' + rootState.user.id,
          data,
          {
            params,
          }
        )
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            return data
          } else {
            throw new Error(
              'Impossible de récupérer la liste des etablisements'
            )
          }
        })
    },
    getEstablishmentsList({ commit, state, rootState }, params = {}) {
      let data = {
        companyId: lodash.get(params, 'company_id', null),
        //establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return axios
        .post(
          rootState.apiBaseURL + '/establishmentsList/' + rootState.user.id,
          data,
          {
            params,
          }
        )
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            return data
          } else {
            throw new Error(
              'Impossible de récupérer la liste des etablisements'
            )
          }
        })
    },
    getFunctions({ rootState }, params = {}) {
      let data = {
        companyId: lodash.get(rootState, 'company.id', null),
        establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return axios
        .post(rootState.apiBaseURL + '/functions/' + rootState.user.id, data, {
          params,
        })
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des functions')
          }
        })
      },
      getServices({ rootState }, params = {}) {
        let data = {
          companyId: lodash.get(rootState, 'company.id', null),
          establishmentId: lodash.get(rootState, 'establishment.id', null),
        }
        return axios
        .post(rootState.apiBaseURL + '/services/' + rootState.user.id, data, {
          params,
        })
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des services')
          }
        })
    },
    getSessionsByCompany({ commit, state, rootState }, params = {}) {
      if (params.companyId)
        return axios
          .post(
            rootState.apiBaseURL + '/company-sessions/' + params.companyId,
            {
              params,
            }
          )
          .then((response) => {
            if (lodash.get(response, 'data.data', false)) {
              let data = response.data.data
              return data
            } else {
              throw new Error('Error')
            }
          })
    },
    getTraineeOptions(
      { commit, state, rootState },
      { establishmentId, type } = {}
    ) {
      if (establishmentId && type)
        return axios
          .post(
            rootState.apiBaseURL + `/trainee-${type}/` + establishmentId,
            {},
            {}
          )
          .then((response) => {
            if (lodash.get(response, 'data.data', false)) {
              return response.data.data
            } else {
              throw new Error('Impossible de récupérer la liste des services')
            }
          })
      else return new Promise((r, e) => e('Empty params'))
    },
    setTraineeOptions(
      { commit, state, rootState },
      { establishmentId, title, type } = {}
    ) {
      if (establishmentId && type && title)
        return axios
          .post(
            rootState.apiBaseURL + `/${type}`,
            { establishmentId, title },
            {}
          )
          .then((response) => {
            if (response.data.success) {
              return response.data.success
            } else {
              throw new Error('Impossible de récupérer la liste des services')
            }
          })
      else return new Promise((r, e) => e('Empty params'))
    },
    filter({ commit, state, rootState }, { params = {} }) {
      let data = {
        companyId: lodash.get(rootState, 'company.id', null),
        establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return axios
        .post(
          rootState.apiBaseURL + '/client-trainees/' + rootState.user.id,
          data,
          {
            params,
          }
        )
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            let meta = response.data.meta
            commit('SET_TRAINEES', { data: data, meta: meta })
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des stagaires')
          }
        })
    },
    exportTrainee({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/trainees/export', params, {
            responseType: 'blob',
          })
          .then((response) => {
            if (response) {
              resolve(response)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    exportTrainingPlan({ commit, state, rootState }, params = {}) {
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/training-plan/export', params, {
            responseType: 'blob',
          })
          .then((response) => {
            if (response) {
              resolve(response)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    registerTrainee({ commit, state, rootState }, params = {}) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      params.establishmentId = lodash.get(rootState, 'establishment.id', null)
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/registrations', params)
          .then((response) => {
            if (response) {
              resolve(response)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    registerCompliance({ commit, state, rootState }, params = {}) {
      params.companyId = lodash.get(rootState, 'company.id', null)
      return new Promise((resolve, reject) => {
        axios
          .post(rootState.apiBaseURL + '/compliances/registrations', params)
          .then((response) => {
            if (response) {
              resolve(response)
            }
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    searchTrainees({ commit, state, rootState }, { params = {} }) {
      let data = {
        companyId: lodash.get(rootState, 'company.id', null),
        establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return new Promise((resolve, reject) => {
        axios
          .post(
            rootState.apiBaseURL + '/client-trainees/' + rootState.user.id,
            data,
            {
              params,
            }
          )
          .then((response) => {
            let resp = []
            if (lodash.get(response, 'data.data')) {
              let resp = response.data.data
              let meta = response.data.meta
              commit('SET_FILTRED_LIST', { data: resp })
              commit('SET_TRAINEES', { data: data, meta: meta })
            }
            resolve(resp)
          })
          .catch((error) => {
            console.log(error)
            reject(error)
          })
      })
    },
    getTrainees({ commit, rootState }, params = {}) {
      let data = {
        companyId: lodash.get(rootState, 'company.id', null),
        establishmentId: lodash.get(rootState, 'establishment.id', null),
      }
      return axios
        .post(
          rootState.apiBaseURL + '/client-trainees/' + rootState.user.id,
          data,
          {
            params,
          }
        )
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            let meta = response.data.meta
            commit('SET_TRAINEES', { data: data, meta: meta })
            return data
          } else {
            throw new Error('Impossible de récupérer la liste des stagaires')
          }
        })
    },
    getTraineeById({ commit, rootState }, data = {}) {
      let params = data?.params
      return axios
        .get(rootState.apiBaseURL + '/trainees/' + data.traineeId, {
          params,
        })
        .then((response) => {
          if (lodash.get(response, 'data.data', false)) {
            let data = response.data.data
            return data
          } else {
            throw new Error('Impossible de récupérer le stagaire')
          }
        })
    },
    getCompliances({ commit, rootState }, params = {}) {
      return axios
        .get(rootState.apiBaseURL + '/clients/compliances/' + 28)
        .then((response) => {
          let data = {}
          if (lodash.get(response, 'data', false)) {
            data = response.data
            commit('SET_COMPLIANCE_LIST', data)
          } else {
            data = []
          }
          return data
        })
    },
  },
  getters: {},
}
export default trainees
